export const colors = {
  spinachCore: "#038231",
  spinach10: "#03752C",
  spinachMinus80: "#CDE6D6",
  spinachMinus90: "#E6F3EA",

  grapefruitCore: "#ff595a",
  grapefruit10: "#E55051",
  grapefruit20: "#CC4748",
  grapefruit60: "#662424",
  grapefruitMinus70: "#FFCDCE",
  grapefruitMinus80: "#FFDEDE",
  grapefruitMinus90: "#FFEEEE",

  green100: "#D1E7DD",
  green600: "#146C43",

  bananaCore: "#FF9E18",
  banana10: "#E58E16",
  banana60: "#663f0a",
  bananaMinus70: "#ffe2ba",
  bananaMinus90: "#FFF5E8",

  eggPlantCore: "#5941B0",
  eggPlantMinus80: "#DED9EF",
  eggPlantMinus90: "#EEECF7",

  rasberryCore: "#AC3C72",
  rasberryMinus90: "#F7EBF1",

  blackMinus30: "#514C61",
  blackMinus40: "#6A6678",
  blackMinus50: "#83808E",
  blackMinus60: "#9C99A5",
  blackMinus70: "#B4B3BC",

  yellow100: "#FFF3CD",
  primaryDark: "#47348D",
  lightGray: "#F0F0F4",

  // Mirrors of the FM status accents (`--fm-status-warning-accent`,
  // `--fm-status-info-accent` in fm.css) for the one medium a CSS var cannot
  // reach: SVG paint attributes set from JS, as chart libraries do.
  statusWarningAccent: "#C77700",
  statusInfoAccent: "#1D6FD6",
};
